/**
 * Avatar utility functions for handling profile avatars
 */

// Colors for avatar backgrounds
const AVATAR_COLORS = [
  '#E57373', // red
  '#F06292', // pink
  '#BA68C8', // purple
  '#9575CD', // deep purple
  '#7986CB', // indigo
  '#64B5F6', // blue
  '#4FC3F7', // light blue
  '#4DD0E1', // cyan
  '#4DB6AC', // teal
  '#81C784', // green
  '#AED581', // light green
  '#FFD54F', // amber
  '#FFB74D', // orange
  '#FF8A65', // deep orange
];

/**
 * Generates a consistent color based on a string (usually a name)
 * @param {string} string - Input string to generate color from
 * @returns {string} - Hex color code
 */
export function stringToColor(string: string): string {
  let hash = 0;
  for (let i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  // Use the hash to select a color from our predefined palette
  const index = Math.abs(hash) % AVATAR_COLORS.length;
  return AVATAR_COLORS[index];
}

/**
 * Gets the initials from a name
 * @param {string} name - Full name
 * @returns {string} - Initials (up to 2 characters)
 */
export function getInitials(name: string): string {
  const parts = name.split(' ').filter(part => part.length > 0);
  let initials = '';
  
  if (parts.length === 0) return 'U';
  
  if (parts.length === 1) {
    initials = parts[0][0];
  } else {
    initials = parts[0][0] + parts[parts.length - 1][0];
  }
  
  return initials.toUpperCase();
}

/**
 * Creates props for MUI Avatar component from a name
 * @param {string} name - User's full name
 * @returns {object} - Props for Avatar component
 */
export function stringAvatar(name: string): { sx: { bgcolor: string}, children: string } {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: getInitials(name),
  };
}

// Remove the default export if only named exports are needed
// export default {
//   stringAvatar,
//   stringToColor,
//   getInitials,
// }; 